import api from '../api/api';

const BASE_URL = '/audit-logs';

const auditLogsAPI = {
  findAll: async (params = {}) => {
    const response = await api.get(BASE_URL, { params });
    return response.data;
  },

  getEntityTypes: async () => {
    const response = await api.get(`${BASE_URL}/entity-types`);
    return response.data;
  },
};

export default auditLogsAPI;
